import ServiceExec from '@/common/utils/ServiceExec';
import { announcement, funeral } from '@/common/service/apiList';
import {
  asFormData,
  churchCityLetterCut,
  convertToLocalDateTime,
  fileRequestBinding,
  isEmpty,
  REMOVE_EMPTY_PARAMS
} from '@/common/utils/Util';
import { cloneDeep } from 'lodash';
import store from '@/store';
import { nativeDownload } from '@/common/utils/module/NativeRequest';
import { CODE_ENV_LIST } from '@/common/constants/ConstCode';
import dayjs from 'dayjs';
const {
  getList,
  getDetail,
  pushComment,
  removeComment,
  removeFuneral,
  saveFuneral,
  updateFuneral,
  excelDownload
} = funeral;

export default {
  async getFunerals({ commit, getters, state }, payload) {
    let reqData = cloneDeep(state.condition);
    if (reqData.page > state.pageInfo.endPage) return;
    if (!isEmpty(payload)) {
      Object.assign(reqData, payload);
    }
    const { data, status } = await ServiceExec.get(getList, { ...REMOVE_EMPTY_PARAMS(reqData) });
    if (status !== ServiceExec.status.OK) return false;
    const { list, pageInfo } = data;
    if (isEmpty(list)) return;
    reqData.page = reqData.page + 1;
    commit('setCondition', reqData);
    commit('setPageInfo', pageInfo);
    commit('setFunerals', list ?? []);
  },
  async getAnnouncementList({ commit, state }) {
    const reqData = cloneDeep(state.announcementCondition);
    if (reqData.page > state.announcementPageInfo.endPage) return;
    const { userNo } = store.getters['user/getUserData'];
    reqData.userNo = userNo;
    const { data, status } = await ServiceExec.get(announcement.getAnnouncementList, {
      ...REMOVE_EMPTY_PARAMS(reqData)
    });
    if (status !== ServiceExec.status.OK) return false;
    const { list, pageInfo } = data;
    if (isEmpty(list)) return;
    reqData.page = reqData.page + 1;
    commit('setAnnouncementCondition', reqData);
    commit('setAnnouncementPageInfo', pageInfo);
    commit('setObituaryList', list ?? []);
  },
  async getDetail({ commit, getters, state }, funeralNo) {
    const { data, status } = await ServiceExec.get(getDetail + funeralNo);
    if (status !== ServiceExec.status.OK) return false;
    commit('setDetail', data ?? '');
  },

  async fetchAnnouncement({ commit, getters, state }, funeralNo) {
    const { data, status } = await ServiceExec.get(announcement.getAnnouncement(funeralNo));
    if (status !== ServiceExec.status.OK) return false;
    commit('setObituaryDetail', data ?? '');
  },

  async getComment({ commit, getters, state }, funeralNo) {
    const { data, status } = await ServiceExec.get(getDetail + funeralNo);

    if (status !== ServiceExec.status.OK) return false;
    commit('setCommentList', data.commentList ?? '');
    return true;
  },
  async pushComment({ commit, getters, state }, payload) {
    delete payload.memorialNo;
    const { status, data } = await ServiceExec.post(pushComment, payload);
    if (status !== ServiceExec.status.OK) return false;

    commit('setCommentList', [...state.detail.commentList, data]);
  },
  async removeComment({ commit, getters, state }, commentNo) {
    const { status } = await ServiceExec.delete(removeComment + commentNo);
    if (status !== ServiceExec.status.OK) return false;
  },

  async removeFuneral({ commit, getters, state }, funeralNo) {
    const { status } = await ServiceExec.patch(removeFuneral + funeralNo);
    return status === ServiceExec.status.OK;
  },

  async removeObituary({ commit, getters, state }, announcementNo) {
    const { status } = await ServiceExec.patch(announcement.remove + announcementNo);
    return status === ServiceExec.status.OK;
  },

  /**
   * 온라인 부고장 수정
   * @param payload
   * @return {Promise<boolean>}
   */
  async updateObituary({ commit, getters, state }, payload) {
    let reqParams = cloneDeep(payload);
    funeralFormat(reqParams);
    const { status } = await ServiceExec.multiPut(announcement.update, asFormData(REMOVE_EMPTY_PARAMS(reqParams)));
    return status === ServiceExec.status.OK;
  },

  async updateFuneral({ commit, getters, state }, payload) {
    let reqParams = cloneDeep(payload);
    const { familyCode } = store.getters['user/getUserData'];
    fileRequestBinding(reqParams, 'rawFile');
    reqParams.churchName = churchCityLetterCut(reqParams.churchName);
    reqParams.familyCode = familyCode;
    reqParams.family = JSON.stringify(reqParams.family);
    const { status } = await ServiceExec.multiPut(updateFuneral, asFormData(REMOVE_EMPTY_PARAMS(reqParams)));
    return status === ServiceExec.status.OK;
  },

  async saveFuneral({ commit, getters, state }, payload) {
    let reqParams = cloneDeep(payload);
    funeralFormat(reqParams);
    fileRequestBinding(reqParams, 'rawFile');
    reqParams = asFormData(reqParams);
    const { status, data } = await ServiceExec.multiPost(saveFuneral, reqParams);

    if (status !== ServiceExec.status.OK) return false;
    return data;
  },

  async excelDownload({ commit, getters, state }, payload) {
    const today = dayjs().format('_YYYYMMDD');
    nativeDownload(
      CODE_ENV_LIST.DYNAMIC_DOMAIN + '/' + excelDownload(payload.funeralNo),
      `온라인_장례식장_헌화내역_${today}.xlsx`
    );
  }
};
const funeralFormat = reqParams => {
  const { userNo, churchNo, familyCode } = store.getters['user/getUserData'];
  reqParams.userNo = userNo;
  reqParams.familyCode = familyCode;
  reqParams.churchNo = churchNo;
  reqParams.churchName = churchCityLetterCut(reqParams.churchName);
  reqParams.family = JSON.stringify(reqParams.family);
  // reqParams.casketDate = convertToLocalDateTime(reqParams.casketDate);
  // reqParams.carryDate = convertToLocalDateTime(reqParams.carryDate);
};
